import { LitheElement, LitheFC } from '@wheelbox/lithejs-engine';

import withPageTitle from '@lib/page';

import {
  HeroSection,
  FeaturesSection,
  CodeExamplesSection,
  EcosystemSection,
  TestimonialsSection,
  CTASection,
} from './sections';

const HomePage: LitheFC = ({
  id = 'home-page',
  testId = 'home-page',
}): LitheElement<'main'> => {
  withPageTitle('LitheJS | Welcome');

  return [
    'main',
    {
      id,
      'data-testid': testId,
      class: 'min-h-screen',
    },
    HeroSection({ id: 'hero' }),
    FeaturesSection({ id: 'features' }),
    CodeExamplesSection({ id: 'code-examples' }),
    EcosystemSection({ id: 'ecosystem' }),
    TestimonialsSection({ id: 'testimonials' }),
    CTASection({ id: 'cta' }),
  ];
};

export default HomePage;
